import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f106672"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "rt-visually-hidden" }, "Blip. The big timer.", -1))
const _hoisted_2 = {
  key: 0,
  class: "rt-pairing-modal"
}
const _hoisted_3 = {
  class: "rt-timer__settings-row",
  style: {"visibility":"hidden"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", null, "Settings", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Controller connected ")
const _hoisted_7 = {
  class: "rt-timer__display-row",
  "aria-hidden": "true"
}
const _hoisted_8 = { class: "rt-timer__display-time" }
const _hoisted_9 = ["max", "value"]
const _hoisted_10 = {
  key: 0,
  class: "rt-message"
}
const _hoisted_11 = {
  key: 0,
  "aria-label": "Timer quick-set options"
}
const _hoisted_12 = { class: "rt-timer__quick-set-row" }
const _hoisted_13 = ["onClick", "aria-label"]
const _hoisted_14 = { class: "rt-timer__controls-row" }
const _hoisted_15 = {
  key: 0,
  class: "rt-control-spacer",
  "aria-hidden": "true"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "rt-main-control__icon rt-main-control__icon--play",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 35.72 50.33"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M976.17,537.58l-28.39-21.5A3.67,3.67,0,0,0,941.9,519v43a3.67,3.67,0,0,0,5.88,2.93l28.39-21.5A3.67,3.67,0,0,0,976.17,537.58Z",
    transform: "translate(-941.9 -515.33)",
    fill: "currentColor"
  })
], -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "rt-main-control__icon rt-main-control__control--pause",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 35.76 50.25",
  "aria-visbile": "false"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    width: "14.47",
    height: "50.25",
    rx: "3.57",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "21.29",
    width: "14.47",
    height: "50.25",
    rx: "3.57",
    fill: "currentColor"
  })
], -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "rt-secondary-control__icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 44.81 39.05",
  "aria-visbile": "false"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M43.28,11.92A19.55,19.55,0,0,0,32.89,1.54,19.53,19.53,0,0,0,11.48,5.72a19.6,19.6,0,0,0-4.18,6.2,19.4,19.4,0,0,0-1.53,7.6v0A1.41,1.41,0,0,1,4.37,21h-3A1.4,1.4,0,0,0,.33,23.27L8.51,33a1.41,1.41,0,0,0,2.18,0l7.75-9.73A1.4,1.4,0,0,0,17.34,21h-3a1.4,1.4,0,0,1-1.41-1.37v-.07A12.38,12.38,0,1,1,25.29,31.9a12.09,12.09,0,0,1-4.48-.84,1.39,1.39,0,0,0-1.59.48l-2.7,3.55A1.4,1.4,0,0,0,17,37.2,19.29,19.29,0,0,0,19,38a19.73,19.73,0,0,0,6.33,1,19.55,19.55,0,0,0,18-27.13Z",
    fill: "#fff"
  })
], -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  class: "rt-visually-hidden",
  "aria-live": "assertive",
  "aria-atomic": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.pairingModalOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_qrcode_vue, {
            value: _ctx.pairingUrl,
            size: 300,
            level: "L",
            class: "rt-pairing-modal__qr-code"
          }, null, 8, ["value"]),
          _createTextVNode(" Or go to " + _toDisplayString(_ctx.pairingDisplayUrl) + " and enter the code " + _toDisplayString(_ctx.pairingSecrets.pairingCode) + " ", 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelPairingModal && _ctx.cancelPairingModal(...args)))
          }, "Cancel")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["rt-timer", _ctx.timerDisplayClasses])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (!_ctx.pairingModalOpen && !_ctx.paired)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showPairingModal && _ctx.showPairingModal(...args)))
            }, " Connect controller "))
          : _createCommentVNode("", true),
        (_ctx.paired)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.unpair && _ctx.unpair(...args)))
              }, "Disconnect controller")
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.displayTime), 1),
        _createElementVNode("div", {
          class: "rt-progress",
          max: _ctx.timerTargetMs,
          value: _ctx.timerMsProgress
        }, [
          _createElementVNode("div", {
            class: "rt-progress__position",
            style: _normalizeStyle({ left: `${_ctx.timerElapsedPercent}%` })
          }, null, 4),
          _createElementVNode("div", {
            class: "rt-progress__elapsed",
            style: _normalizeStyle({ width: `${_ctx.timerElapsedPercent}%` })
          }, null, 4),
          _createElementVNode("div", {
            class: "rt-progress__remaining",
            style: _normalizeStyle({ width: `${_ctx.timerRemainingPercent}%` })
          }, null, 4)
        ], 8, _hoisted_9),
        _createVNode(_Transition, { name: "rt-quick-set-transition" }, {
          default: _withCtx(() => [
            (_ctx.displayMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.displayMessage), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createVNode(_Transition, { name: "rt-quick-set-transition" }, {
        default: _withCtx(() => [
          (_ctx.timerState != _ctx.TimerState.RUNNING)
            ? (_openBlock(), _createElementBlock("nav", _hoisted_11, [
                _createElementVNode("ul", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quickSetOptionsSeconds, (option) => {
                    return (_openBlock(), _createElementBlock("li", { key: option }, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.quickSet(option)),
                        class: "rt-quick-set-button",
                        "aria-label": `Set timer to ${_ctx.quickSetLabelAria(option)}`
                      }, _toDisplayString(_ctx.quickSetLabel(option)), 9, _hoisted_13)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_14, [
        (
          _ctx.timerState === _ctx.TimerState.PAUSED || _ctx.timerState === _ctx.TimerState.FINISHED
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_15))
          : _createCommentVNode("", true),
        (_ctx.timerState != _ctx.TimerState.RUNNING)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "rt-main-control",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.startTimer && _ctx.startTimer(...args))),
              "aria-label": "Start timer",
              ref: "startButton",
              role: "button",
              tabindex: "0"
            }, _hoisted_17, 512))
          : _createCommentVNode("", true),
        (_ctx.timerState === _ctx.TimerState.RUNNING)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "rt-main-control",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.pauseTimer && _ctx.pauseTimer(...args))),
              "aria-label": "Pause timer",
              ref: "pauseButton",
              role: "button",
              tabindex: "0"
            }, _hoisted_19, 512))
          : _createCommentVNode("", true),
        (
          _ctx.timerState === _ctx.TimerState.PAUSED || _ctx.timerState === _ctx.TimerState.FINISHED
        )
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              class: "rt-secondary-control",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetTimer && _ctx.resetTimer(...args))),
              "aria-label": "Reset timer",
              ref: "resetButton"
            }, _hoisted_21, 512))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.audibleStatus), 1)
  ], 64))
}